import "../../assets/index9.css";
import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { I as m } from "../../chunks/index.ed48ee81.js";
import { m as I } from "../../chunks/make-refs.cb0b9b76.js";
import { c as $ } from "../../chunks/index.bddf5ebb.js";
import { forwardRef as j, useState as k } from "react";
const H = "_notification_eebhf_1", R = "_dismiss_eebhf_19", D = "_container_eebhf_26", M = "_text_eebhf_32", S = "_heading_eebhf_41", T = "_hidden_eebhf_70", q = "_success_eebhf_74", z = "_warning_eebhf_82", A = "_error_eebhf_90", s = {
  notification: H,
  dismiss: R,
  container: D,
  text: M,
  heading: S,
  hidden: T,
  success: q,
  warning: z,
  error: A
}, O = j(
  ({
    a11yDismissLabel: d,
    a11yDismissTitle: l,
    bodyText: o,
    children: c,
    className: _,
    hasDismissButton: h = !0,
    heading: r,
    onClose: n,
    variant: i = "info",
    ...b
  }, u) => {
    const { $el: p, $dismiss: g } = I(u, ["$el", "$dismiss"]), a = {
      info: "24/symbol/information",
      success: "24/symbol/status-success",
      warning: "24/symbol/status-alert",
      error: "24/symbol/status-error"
    }, y = a[i] || a.info, [t, N] = k(!1), x = () => {
      N(!t), n == null || n();
    }, w = $(s.notification, _, {
      [s[i]]: i !== "info",
      [s.hidden]: t
    });
    return /* @__PURE__ */ f(
      "div",
      {
        role: i === "error" || i === "warning" ? "alert" : "note",
        ref: p,
        className: w,
        "aria-hidden": t,
        ...b,
        children: [
          /* @__PURE__ */ e(m, { icon: y }),
          /* @__PURE__ */ f("div", { className: s.container, children: [
            r && /* @__PURE__ */ e("strong", { className: s.heading, children: r }),
            c || o ? /* @__PURE__ */ e("p", { className: s.text, children: c || o }) : null
          ] }),
          h && /* @__PURE__ */ e(
            "button",
            {
              "aria-label": d,
              className: s.dismiss,
              onClick: x,
              ref: g,
              title: l,
              type: "button",
              children: /* @__PURE__ */ e(m, { icon: "24/symbol/x" })
            }
          )
        ]
      }
    );
  }
);
export {
  O as Notification
};
//# sourceMappingURL=index.js.map
